import { IncentivizeRewardsDto, PerformanceFeeDto } from '../types/spool-local';
import InfoPopUp from '../../components/InfoPopUp';
import { formatPercentages } from '../../helpers/formats';

type Props = {
    baseApy: string;
    incentivizedRewards: IncentivizeRewardsDto[];
    performanceFees: PerformanceFeeDto;
    adjustedApy: string;
};

const AdjustedApy: React.FC<Props> = ({
    baseApy,
    incentivizedRewards,
    performanceFees,
    adjustedApy,
}) => (
    <InfoPopUp className='adjusted-apy'>
        <div>
            <span>Adjusted APY: </span>
            <strong>{formatPercentages(parseFloat(adjustedApy) * 100 || 0)}%</strong>
        </div>
        <div className='mt border-top'>
            <div>
                <span>Stablecoin APY: </span>
                <strong>{formatPercentages(parseFloat(baseApy) * 100 || 0)}%</strong>
            </div>
            {incentivizedRewards?.length
                ? incentivizedRewards
                      .filter(({ isRemoved }) => !isRemoved)
                      .map(({ symbol, apy, id }) => (
                          <div key={id}>
                              <span>{symbol} APY: </span>
                              <strong>
                                  {formatPercentages(parseFloat(apy) * 100 || 0)}%
                              </strong>
                          </div>
                      ))
                : null}
        </div>
        <div className='mt'>
            <span className='block'>Performance Fees:</span>
            <div>
                <span>Spool Creator: </span>
                <span>{formatPercentages(performanceFees.owner || 0)}%</span>
            </div>
            <div>
                <span>Risk Model: </span>
                <span>{formatPercentages(performanceFees.riskProvider || 0)}%</span>
            </div>
            <div>
                <span>DAO: </span>
                <span>
                    {formatPercentages(
                        +performanceFees.treasury + +performanceFees.ecosystem || 0
                    )}
                    %
                </span>
            </div>
        </div>
    </InfoPopUp>
);

export default AdjustedApy;
